import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IMerchantPriceStampRatioTrend } from '@/shared/model/merchant-price-stamp-ratio-trend.model';

const baseApiUrl = 'api/merchant-price-stamp-ratio-trends';
const baseSearchApiUrl = 'api/_search/merchant-price-stamp-ratio-trends?query=';

export default class MerchantPriceStampRatioTrendService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IMerchantPriceStampRatioTrend> {
    return new Promise<IMerchantPriceStampRatioTrend>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IMerchantPriceStampRatioTrend): Promise<IMerchantPriceStampRatioTrend> {
    return new Promise<IMerchantPriceStampRatioTrend>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IMerchantPriceStampRatioTrend): Promise<IMerchantPriceStampRatioTrend> {
    return new Promise<IMerchantPriceStampRatioTrend>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
